import { getDefaultExportFromCjs } from " commonjsHelpers.js";
import { __require as requireJobVacanciesDetails } from "/web/src/js/roundhouse/misc/hr/job-vacancies-details.js";
var jobVacanciesDetailsExports = requireJobVacanciesDetails();
export { jobVacanciesDetailsExports as __moduleExports };
export default /*@__PURE__*/getDefaultExportFromCjs(jobVacanciesDetailsExports);